import { styled } from '@fluentui/react/lib/Utilities';
import { StackedBarChartBase } from './StackedBarChart.base';
import { getStyles } from './StackedBarChart.styles';
// Create a StackedBarChart variant which uses these default styles and this styled subcomponent.
export var StackedBarChart = styled(StackedBarChartBase, getStyles);
//# sourceMappingURL=StackedBarChart.js.map